import { render, staticRenderFns } from "./ProviderLevyAmountsWidget.vue?vue&type=template&id=333be44b&"
import script from "./ProviderLevyAmountsWidget.vue?vue&type=script&lang=js&"
export * from "./ProviderLevyAmountsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports